import { Typography } from "@material-ui/core";
import React from "react";
import { styleShare } from "../orders/OrderCard";

export const RowInfo = (props) => {
  const { leftLabel, rightLabel } = props;
  return (
    <>
      <div style={{ ...styleShare, height: 32, paddingTop: 24 }}>
        <Typography variant="caption" color="primary">
          {leftLabel}:
        </Typography>
        <Typography variant="caption" bold>
          {rightLabel}
        </Typography>
      </div>
    </>
  );
};
